import { configureStore } from '@reduxjs/toolkit'
import appSlice from './slices/appSlice'
import userSlice from './slices/userSlice'
import settingsSlice from './slices/settingsSlice'
import { apiSlice } from './slices/apiSlice'
import pvtCalculatorSlice from './slices/pvtCalculatorSlice'
import iprCalculatorSlice from './slices/iprCalculatorSlice'
import waterContentCalculatorSlice from './slices/waterContentCalculatorSlice'
import hydratesCalculatorSlice from './slices/hydratesCalculatorSlice'
import vlpCalculatorSlice from './slices/vlpCalculatorSlice'
import gasRateCriticalSlice from './slices/gasRateCriticalCalculatorSlice'
import systemPlotSlice from './slices/systemPlotSlice'
import { listenerMiddleware } from './listenerMiddleware'
import './listeners/yandexAuthCallbackListener'
import materialBalanceCalculatorSlice from './slices/materialBalanceCalculatorSlice'
import pressureDropCalculatorSlice from './slices/pressureDropCalculatorSlice'

export const store = configureStore({
	reducer: {
		app: appSlice.reducer,
		user: userSlice.reducer,
		api: apiSlice.reducer,
		settings: settingsSlice.reducer,
		pvtCalculator: pvtCalculatorSlice.reducer,
		iprCalculator: iprCalculatorSlice.reducer,
		vlpCalculator: vlpCalculatorSlice.reducer,
		waterContentCalculator: waterContentCalculatorSlice.reducer,
		hydratesCalculator: hydratesCalculatorSlice.reducer,
		gasRateCriticalCalculator: gasRateCriticalSlice.reducer,
		systemPlot: systemPlotSlice.reducer,
		pressureDropCalculator: pressureDropCalculatorSlice.reducer,
		materialBalance: materialBalanceCalculatorSlice.reducer,
	},
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware().prepend(listenerMiddleware.middleware).concat(apiSlice.middleware),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch